import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

const TestimonialMutawir = () => {
  const { t } = useTranslation();
  const testimonials = t('testimonials.items', { returnObjects: true }) || [];
  const [startIndex, setStartIndex] = useState(0);
  const visibleCount = Math.min(2, testimonials.length);

  useEffect(() => {
    setStartIndex(0);
  }, [testimonials.length]);

  useEffect(() => {
    if (typeof window === 'undefined' || testimonials.length <= visibleCount) {
      return undefined;
    }

    const interval = window.setInterval(() => {
      setStartIndex((previous) => (previous + 1) % testimonials.length);
    }, 6000);

    return () => window.clearInterval(interval);
  }, [testimonials.length, visibleCount]);

  const visibleTestimonials = useMemo(() => {
    if (testimonials.length === 0) {
      return [];
    }

    if (testimonials.length <= visibleCount) {
      return testimonials;
    }

    return Array.from({ length: visibleCount }, (_, offset) => {
      const index = (startIndex + offset) % testimonials.length;
      return testimonials[index];
    });
  }, [startIndex, testimonials, visibleCount]);

  if (testimonials.length === 0) {
    return null;
  }

  return (
    <section id="testimonials" className="section section-padding mutawir-testimonials">
      <div className="container">
        <div className="row g-5 align-items-start mutawir-section-intro">
          <div className="col-xl-8 col-lg-9">
            <div className="mutawir-section-heading">
              <span className="mutawir-tagline">{t('testimonials.tagline')}</span>
              <h2 className="title">{t('testimonials.title')}</h2>
              <p className="mutawir-section-description">{t('testimonials.description')}</p>
            </div>
          </div>
        </div>
        <div className="row g-4 mt--10">
          {visibleTestimonials.map((item, index) => (
            <div className="col-lg-6 col-md-6" key={`${item.name}-${index}`}>
              <div className="mutawir-testimonial-card">
                {item.source && (
                  <span className="mutawir-testimonial-card__source">{item.source}</span>
                )}
                {item.quote && (
                  <p className="mutawir-testimonial-card__quote">{item.quote}</p>
                )}
                <div className="mutawir-testimonial-card__author">
                  <div className="mutawir-testimonial-card__meta">
                    {item.name && (
                      <span className="mutawir-testimonial-card__name">{item.name}</span>
                    )}
                    {item.role && (
                      <span className="mutawir-testimonial-card__role">{item.role}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialMutawir;
